import { initialState } from '../reducers/organisationDirectoryReducer';
import { kioskDefaultState } from '../reducers/kioskReducer';

export const setKiosk = (data) => async dispatch => {
	dispatch({type: 'KIOSK_VIEW', payload: data });
};

export const emptyKioskSection = (clearFilters = true) => async dispatch => {
	dispatch({ type: 'KIOSK_VIEW', payload: {...kioskDefaultState} });
	if (clearFilters) dispatch({type: 'FETCH_KIOSK_FILTERS', payload: {...initialState}});
}